import {LOAD_PARAMETROS_SUCCESS, IParametro} from "../types/parametroActionTypes";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

export function loadParametros() {
    return function (dispatch) {
        return apiSource.obtener<IParametro[]>("parametro/active")
            .then((parametros: IParametro[]) => {
                dispatch({type: LOAD_PARAMETROS_SUCCESS, parametros})
            })
            .catch(error => {
               // throw error;
            })
    }
}
